<template>
  <div class="site-header">
    <!-- 主头条 + 副标题（一体） -->
    <div class="site-header__headline" >
      <a
        v-if="headlineLink"
        class="site-header__headline-text"
        :href="headlineLink"
        target="_blank"
        rel="noopener noreferrer"
      >{{ headline }}</a>
      <span v-else class="site-header__headline-text">{{ headline }}</span>
    
      <a
        v-if="subTitle1Link"
        class="site-header__sub-1"
        :href="subTitle1Link"
        target="_blank"
        rel="noopener noreferrer"
      >{{ subTitle1 }}</a>
      <span v-else class="site-header__sub-1">{{ subTitle1 }}</span>

      <!-- <a
        v-if="subTitle2Link"
        class="site-header__sub-1"
        :href="subTitle2Link"
        target="_blank"
        rel="noopener noreferrer"
      >{{ subTitle2 }}</a>
      <span v-else class="site-header__sub-1">{{ subTitle2 }}</span> -->
    </div>
  </div>
</template>

<script>
import request from '../../../api/request'

export default {
  name: 'SiteHeader',
  props: {
    headline: { type: String, required: true },
    headlineLink: { type: String, default: '' },
    subTitle1: { type: String, default: '' },
    subTitle1Link: { type: String, default: '' },
    subTitle2: { type: String, default: '' },
    subTitle2Link: { type: String, default: '' }
  },
  data() {
    return {
      newsList: [], // 新闻列表
      currentHeadline: this.headline, // 当前主标题
      currentSubTitle1: this.subTitle1 // 当前副标题 1
    }
  },
  mounted() {
    this.loadMainTitle()
    this.loadSubTitle1()
  },
  methods: {
    async loadMainTitle() {
      try {
        const res = await request.post('/api/index/getIndexRecommendInfo', {
          positionKey: 'index_main_title'
        })
        if (res.code === 200 && res.data) {
          if (res.data.positionKey === 'index_main_title' && res.data.newsList && res.data.newsList.length > 0) {
            const firstNews = res.data.newsList[0]
            this.headline = firstNews.title
            // 存储新闻 code 用于跳转
            this.headlineLink = '/detail?newsCode=' + firstNews.newsCode
          }
        }
      } catch (err) {
        console.error('获取主标题失败:', err)
      }
    },
    async loadSubTitle1() {
      try {
        const res = await request.post('/api/index/getIndexRecommendInfo', {
          positionKey: 'index_sub_title'
        })
        if (res.code === 200 && res.data) {
          if (res.data.positionKey === 'index_sub_title' && res.data.newsList && res.data.newsList.length > 0) {
            const firstNews = res.data.newsList[0]
             const secondNews = res.data.newsList[1]
            this.subTitle1 = firstNews.title
            this.subTitle1Link = '/detail?newsCode=' + firstNews.newsCode
            this.subTitle2 = secondNews.title
            this.subTitle2Link = '/detail?newsCode=' + secondNews.newsCode
          }
        }
      } catch (err) {
        console.error('获取副标题失败:', err)
      }
    }
  }
};
</script>

<style scoped>
/* ── 容器 ── */
.site-header {
  position: relative;
  width: var(--page-width);
}

/* 主头条 + 副标题容器 */
.site-header__headline {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: var(--page-width);
  background-color: #ffffff;
  opacity: 0.99;
  margin-top: 11px;
  padding: 20px var(--space-6) 16px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
}

.site-header__headline::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: var(--space-6);
  right: var(--space-6);
  height: 0;
  border-bottom: 2px solid #EBEBEB;
}

.site-header__headline-text {
  width: var(--content-width);
  color: var(--color-primary-dark);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  text-align: center;
  white-space: nowrap;
  line-height: 40px;
  text-decoration: none;
}

/* 副标题（与主标题一体） */
.site-header__sub-1 {
  display: block;
  width: var(--content-width);
  color: var(--color-text-gray);
  font-size: var(--font-xl);
  font-family: var(--font-primary);
  text-align: center;
  margin-top: 14px;
  line-height: 36px;
  text-decoration: none;
}

.site-header__sub-2 {
  display: block;
  width: var(--content-width);
  color: var(--color-black);
  font-size: var(--font-2xl);
  font-family: var(--font-primary);
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin: 39px 0 19px var(--space-6);
}
</style>
